import { useContext } from 'react';
import { camelCase, get } from 'lodash';
import { FeatureFlagContext } from 'common/contexts/FeatureFlagContext';

/**
 * @param {string} flagName - Feature flag to be evaluated (e.g. "pays-3535-service-authorization-wq-filterbar")
 * @return {boolean} - Is the feature flag enabled?
 */
const useFeatureFlag = (flagName) => {
  const flags = useContext(FeatureFlagContext);
  return get(flags, camelCase(flagName));
};

export default useFeatureFlag;
